export const translations = {
    WHATSAPP_MESSAGE: "Ciao! Ho trovato il tuo profilo su EscortFun.net e vorrei incontrarti.",
}